import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';

import { IncodeContainer } from '../../IncodeContainer';
import type { IncodeStepProps } from '../../IncodeSDKHelpers';
import { INCODE_PROGRESS_STATUS, INCODE_PROGRESS_STEP, INCODE_ROUTES } from '../../IncodeSDKHelpers';
import { usePostIncodeProgress } from '../../progress/incodeProgress';
import { IncodeCaptureDevHelper } from '../IncodeCaptureDevHelper';

import styles from './IncodeCaptureProofOfAddress.module.scss';

export const IncodeCaptureProofOfAddress = ({
  BASE_URL,
  incodeSDK,
  incodeSession,
}: IncodeStepProps) => {
  const incodeContainerRef = useRef<HTMLDivElement>(null);

  const history = useHistory();
  const { IncodeProgressLoading, postIncodeComplete } = usePostIncodeProgress();

  useEffect(() => {
    const incodeContainerRefCurrent = incodeContainerRef.current;
    const abortController = new AbortController();

    const defaultCompleteParams = {
      abortController,
      fallbackNextStep: INCODE_ROUTES.COMPLETE,
      incodeSession,
      step: INCODE_PROGRESS_STEP.PROOF_OF_ADDRESS,
    };

    const { close } = incodeSDK.renderCamera('document', incodeContainerRefCurrent, {
      nativeCamera: true,
      onError: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.FAILED,
      }),
      onSuccess: () => postIncodeComplete({
        ...defaultCompleteParams,
        status: INCODE_PROGRESS_STATUS.SUCCESS,
      }),
      token: incodeSession,
    });

    return () => {
      abortController.abort();
      close();
    };
  }, [BASE_URL, history, incodeContainerRef, incodeSDK, incodeSession, postIncodeComplete]);

  return (
    <>
      <IncodeProgressLoading />
      <IncodeContainer ref={incodeContainerRef} noStyling className={styles.proofOfAddress} />
      <IncodeCaptureDevHelper to={INCODE_ROUTES.COMPLETE} />
    </>
  );
};
